module.exports = __webpack_public_path__ + "img/safr-logo-default.bd6d2e6a.png";